import { UserProps } from "@store/slices/userSlice";
import { getConfig } from "@utils/getConfig";
import { postRequest } from "@utils/axiosInstance";

export function transactionsWithFilters(user: UserProps, payload: object) {
  return postRequest("transactions/withfilters", payload, getConfig(user));
}
